var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7824",
    "data-name": "Grupo 7824",
    transform: "translate(-0.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2785",
    "data-name": "Rect\\xE1ngulo 2785",
    width: 21,
    height: 21,
    rx: 2,
    transform: "translate(0.154)",
    fill: "#11d29e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye_1_",
    "data-name": "eye (1)",
    transform: "translate(3.151 5.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2503",
    "data-name": "Trazado 2503",
    d: "M14.487,7.48S11.771,2.5,7.244,2.5,0,7.48,0,7.48s2.716,4.98,7.244,4.98S14.487,7.48,14.487,7.48Zm-13.425,0a11.891,11.891,0,0,1,1.5-1.85A6.746,6.746,0,0,1,7.244,3.405,6.752,6.752,0,0,1,11.923,5.63a11.891,11.891,0,0,1,1.5,1.85c-.053.079-.11.166-.177.261A11.94,11.94,0,0,1,11.923,9.33a6.754,6.754,0,0,1-4.679,2.225A6.752,6.752,0,0,1,2.564,9.33a11.892,11.892,0,0,1-1.5-1.85Z",
    transform: "translate(0 -2.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2504",
    "data-name": "Trazado 2504",
    d: "M7.669,5.405A2.264,2.264,0,1,0,9.933,7.669,2.264,2.264,0,0,0,7.669,5.405ZM4.5,7.669a3.169,3.169,0,1,1,3.169,3.169A3.169,3.169,0,0,1,4.5,7.669Z",
    transform: "translate(-0.425 -2.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_199",
    "data-name": "Elipse 199",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(5.002 2.79)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.1ef86391000d956d06804870c0345a76.svg";
export { ForwardRef as ReactComponent };